import { inject as r } from "vue";
import { loadingBarApiInjectionKey as n } from "./ghl-ui.es1041.js";
import { throwError as i } from "./ghl-ui.es853.js";
function d() {
  const o = r(n, null);
  return o === null && i("use-loading-bar", "No outer <n-loading-bar-provider /> founded."), o;
}
export {
  d as useLoadingBar
};
